module.exports = __webpack_public_path__ + "static/media/thunder_storm.460c900c.png";